const forms = {
  onRequest: "요청 시", // translated 
  person: "사람", // translated 
  travelDate: "여행 날짜", // translated 
  travelDates: "여행 날짜", // translated 
  cancel: "취소", // translated 
  getPrice: "가격 알아보기", // translated 
};


export default forms;
